module.exports = __webpack_public_path__ + "static/media/login-bg.91110a97.png";